<template>
    <div class="tw:flex tw:flex-col tw:items-center tw:justify-center" :style="{ width: size + 'px' }">
        <svg
            :width="size"
            :height="size"
            :viewBox="`0 0 ${size} ${size}`"
            class="tw:transform tw:-rotate-90"
        >
            <!-- Background arc (full circle) -->
            <circle
                :cx="center"
                :cy="center"
                :r="radius"
                fill="none"
                :stroke="bgColor"
                :stroke-width="strokeWidth"
                stroke-linecap="round"
            />
            <!-- Foreground arc (proportional) -->
            <circle
                :cx="center"
                :cy="center"
                :r="radius"
                fill="none"
                :stroke="color"
                :stroke-width="strokeWidth"
                stroke-linecap="round"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="dashOffset"
                class="tw:transition-all tw:duration-1000 tw:ease-out"
            />
        </svg>
        <!-- Center percentage text (positioned absolutely over the SVG) -->
        <div
            class="tw:absolute tw:flex tw:flex-col tw:items-center tw:justify-center"
            :style="{ width: size + 'px', height: size + 'px' }"
        >
            <span
                class="tw:font-bold tw:text-gray-900"
                :style="{ fontSize: Math.round(size * 0.22) + 'px' }"
            >
                {{ formattedPercentage }}
            </span>
            <span
                v-if="label"
                class="tw:text-gray-500 tw:mt-1"
                :style="{ fontSize: Math.round(size * 0.09) + 'px' }"
            >
                {{ label }}
            </span>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    const props = defineProps({
        percentage: {
            type: Number,
            required: true,
            validator: v => v >= 0 && v <= 100,
        },
        size: {
            type: Number,
            default: 160,
        },
        color: {
            type: String,
            default: '#e30613',
        },
        bgColor: {
            type: String,
            default: '#e5e7eb',
        },
        strokeWidth: {
            type: Number,
            default: 12,
        },
        label: {
            type: String,
            default: '',
        },
    });

    const center = computed(() => props.size / 2);
    const radius = computed(() => (props.size - props.strokeWidth) / 2);
    const circumference = computed(() => 2 * Math.PI * radius.value);

    const normalizedPercentage = computed(() => {
        return Math.max(0, Math.min(100, props.percentage));
    });

    const dashOffset = computed(() => {
        return circumference.value * (1 - normalizedPercentage.value / 100);
    });

    const formattedPercentage = computed(() => {
        return `${normalizedPercentage.value.toFixed(1)}%`;
    });
</script>
